import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ACTIVATION_ROUTE_URLS, PLANS_SHOP_ROUTE_URLS, SHOP_ROUTE_URLS, SUPPORT_ROUTE_URLS } from 'src/app/app.routes.names';
import { ContentfulService } from 'src/services/contentful.service';

@Component({
  selector: 'app-switch-and-save',
  templateUrl: './switch-and-save.component.html',
  styleUrls: ['./switch-and-save.component.scss']
})
export class SwitchAndSaveComponent implements OnInit {
  public SUPPORT_ROUTE_URLS = SUPPORT_ROUTE_URLS;
  public firstThreeQuestions;
  public restQuestions;
  public questionId: string;
  public collapsed = false;
  public showMore = false;
  public threeMonthPlan = 'FREEUP-3MO-UNLIMITED-TT+8GB';

  constructor(private router: Router, private contentfulService: ContentfulService) { }

  ngOnInit(): void {
    this.contentfulService.getQuestionsByCategoryId('faqs', 'switch-and-save').subscribe(questions => {
      if (!!questions) {
        const allQuestions = questions[0].fields.questions;
        this.firstThreeQuestions = allQuestions.slice(0, 3);
        this.restQuestions = allQuestions.slice(3);
      }
    });
  }

  public goToPlans(): void {
    this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.PLANS_AND_FEATURES}/${PLANS_SHOP_ROUTE_URLS.NEW_PLAN}`]);
  }

  public goToPhonesPage(): void {
    this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.PHONES.TYPE}`]);
  }

  public checkYourPhone(): void {
    this.router.navigate([`${ACTIVATION_ROUTE_URLS.BASE}/${ACTIVATION_ROUTE_URLS.CHECK_PHONE}`]);
  }

  public goToPlanDetails(planId): void {
    const params = {};
    // eslint-disable-next-line @typescript-eslint/dot-notation
    params['id'] = planId;
    // eslint-disable-next-line @typescript-eslint/dot-notation
    this.router.navigate([`${SHOP_ROUTE_URLS.BASE}${PLANS_SHOP_ROUTE_URLS.BASE}/${PLANS_SHOP_ROUTE_URLS.DETAILS}`, params['id']]);
  }

  public toggleActive(targetId, answerId): void {
    if (this.questionId === targetId && !this.collapsed) {
      this.questionId = 'q0';
    } else {
      this.questionId = targetId;
      this.collapsed = false;
      this.callRichText(answerId);
    }
  }

  private callRichText(id): void {
    this.contentfulService.getRichText('questions', id);
  }

}
